
define('text!presentation/settings/index/views/index.html',[],function () { return '<div></div>';});

